var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('GNavBar'),_c('h1',{staticClass:"mt-5 pt-5"},[_vm._v("CourseDev")]),_c('hr'),_c('GProjectDetails',{attrs:{"from":_vm.caller}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }